import { type AxiosPromise } from "axios"
import httpModule from "../../../../utils/http"

export const getReference = async (id): Promise<AxiosPromise<any>> =>
  await httpModule.get(`/api/backoffice/v1/referencias/${id}`)
